import React from 'react';
import PageTitle from '@/components/common/PageTitle';
import MenuTaxonomyList from '@/components/menus/MenuTaxonomyList';
import useMenuList from '@/hooks/useMenuList';
import useMenuTaxonomyList from '@/hooks/useMenuTaxonomyList';
import { IMenuTaxonomy } from '@/@types/generated/contentful';

type ComponentProps = {
  query: {
    slug: IMenuTaxonomy['fields']['taxonomy'];
  };
};

const MenuTaxonomyListContainer: React.FC<ComponentProps> = ({ query }) => {
  const menuList = useMenuList();
  const menuTaxonomyList = useMenuTaxonomyList();
  const taxonomy = menuTaxonomyList.find((item) => item.fields.taxonomy === query.slug);
  return (
    <>
      <PageTitle title={taxonomy ? `「${taxonomy.fields.title}」献立` : '献立'} category='MENU' />
      <MenuTaxonomyList menuList={menuList} />
    </>
  );
};

export default MenuTaxonomyListContainer;
